import { Component } from 'react';
import withRouter from '../../lib/withRouter';
import Authentication from './../../session';
import { RadioButton } from 'primereact/radiobutton';
import ClassetDropdown from '../../../classetComponents/classetDropDown';
import { CancelRed, CrossInBox, GreenCheck, RightMarkInCircle, TickBgIcon } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { debounce } from 'lodash';
import ClassetInputText from '../../../classetComponents/classetInputText';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import ClassetCalendar from '../../../classetComponents/classetCalender';
import { paymentModes } from '../../../constants';

// const searchTypeOptions = [
//     { label: 'Student Name', value: 'studentName' },
//     { label: 'Enrollment Number', value: 'enrollmentNumber' }
// ];

class FeeUnassignApproval extends Component {
    constructor(props) {
        super(props);

        this.state = {
            lazyParams: BasicLazyParams,
            searchType: 1,
            searchInput: '',
            studentInfo: [],
            raisedFeeRefundData: {},
            studentId: null,
            searchLevel: 1,
            // searchType: searchTypeOptions[0].value,
            viewRefundDetails: false,
            remarks: '',
            filters: {

                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

            },
            globalFilterValue: '',
            // Unassign dialog states
            openUnAssignDialog: false,
            unAssignInfo: {},
            unassignOption: '', // 'refund', 'advance', 'adjust', 'noAdjustments'
            unassignAmount: '',
            feeInstallments: [],
            installmentAmounts: [], // Changed to array to match new structure
            isLoadingInstallments: false,
            approverRemarks: '', // New field for approver remarks
            // Payment details dialog states
            showPaymentDetailsDialog: false,
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            accountNo: '',
            accountHolderName: '',
            ifscCode: '',
            rrNumber: '',
            upiId: ''
        };
        this.debouncedApiCall = debounce(this.getStudentsInfo, 500);
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData) => {
        this.setState(
            {
                dropdownsData,
                studentId: null
            },
            () => {
                // Check if branchIds is empty array and prevent API call
                if (!this.state?.dropdownsData?.branchIds ||
                    (Array.isArray(this.state?.dropdownsData?.branchIds) && this.state?.dropdownsData?.branchIds.length === 0)) {
                    console.log('No branches selected, skipping API call');
                    this.setState({
                        isLoading: false,
                        studentInfo: [],
                        studentstotalRecords: 0
                    });
                    return;
                }

                this.getStudentsInfo();
            }
        );
    };

    getStudents = () => {
        let academicYear = localStorage.getItem('userAcademicYear');
        // let { lazyParams } = this.state;
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/fine/student`;
        let payload = {
            branchId: this.state.dropdownsData?.branchId,
            boardId: this.state.dropdownsData?.boardId,
            classId: this.state.dropdownsData?.classId,
            sectionId: this.state.dropdownsData?.sectionId,
            academicYear: academicYear
        };
        if (payload?.sectionId) {
            this.service
                .post(url, payload, true)
                .then((data) => {
                    // console.log(data, "datastudent")
                    const studentsData = data?.res?.data.map((each) => {
                        return {
                            label: each?.name,
                            value: each?.user_id
                        };
                    });

                    if (data?.status) {
                        this.setState({
                            students: studentsData,
                            isLoading: false
                        });
                    } else {
                        this.setState({ isLoading: false });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
                    }
                })
                .catch((error) => {
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
        }
    };

    onHandleViewFeeConcessions = (data) => {
        this.setState({
            viewRefundDetails: true,
            raisedFeeRefundData: data
        });
    };
    onHandleRefundClose = () => {
        this.setState(
            {
                viewRefundDetails: false,
                raisedFeeRefundData: {},
                remarks: ''
            },
            () => this.getStudentsInfo()
        );
    };
    onShowDetailedReport = () => {
        this.setState({
            isLoading: true
        });
    };

    handleSetSearchValue = (value) => {
        this.setState(
            {
                searchValue: value,
                dropdownsData: { ...this.state.dropdownsData, boardId: '', branchId: '', classId: '', sectionId: '' }
            },
            () => {
                this.debouncedApiCall();
            }
        );
    };
    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value, studentId: '', searchValue: '', studentsData: [] });
    };

    onStudentChange = (e) => {
        this.setState({ studentId: e.value }, () => {
            this.getStudentsInfo();
        });
    };


    handleSetSearchTypeValue = (value) => {
        this.setState({ searchType: value }, () => {
            if (this.state.searchType == 'studentName') {
                this.setState({ isUserNameSearch: true });
            } else {
                this.setState({ isUserEnrollSearch: true });
            }
        });
    };

    getStudentsInfo = () => {
        let { lazyParams, globalSearch, filterData } = this.state;
        this.setState({ isLoading: true, studentInfo: [] });
        const url = `${baseUrlAdmin}/unassign-approval/get-unassign-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        let academicYear = localStorage.getItem('userAcademicYear');
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : '';
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : '';

        let payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            // studentId: this.state?.studentId,
            studentId: this.state?.dropdownsData?.studentIds,

            academicYear: academicYear,
            username: this.state.searchLevel == 2 ? username : '',
            enrollmentNo: enrollmentNo,
            assignedHeirarchy: this.state?.dropdownsData?.heirarchy,
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res?.data && res.res?.data?.length) {
                        this.setState({
                            isLoading: false,
                            studentInfo: res?.res?.data,
                            totalRecords: res?.res?.totalRecords
                        });
                    } else if (res.res?.data?.length == 0) {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'success', summary: 'No records found.', detail: '', life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };

    onHandleFeUnassignApprove = (rowData, isConfirmed) => {
        this.setState({
            isApproved: isConfirmed ? true : false,
            isRejected: !isConfirmed ? true : false,
            selectedFeeType: rowData
        });
    };
    onUnassignFeeConfirm = (status) => {
        // Validate approver remarks
        if (!this.state.approverRemarks || this.state.approverRemarks.trim() === '') {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Approver remarks are mandatory',
                life: 3000
            });
            return;
        }

        this.setState({
            isLoading: true
        });

        let payload = {
            ...this.state.selectedFeeType,
            isAssigned: status,
            remarks: this.state.selectedFeeType?.remarks || '', // Original requested remarks
            approverRemarks: this.state.approverRemarks, // New approver remarks
            handledBy: this.state.selectedFeeType?.handledBy || [],
            levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == this.state.selectedFeeType?.branchId)
        };
        let url = `${baseUrlAdmin}/unassign-approval/unassign-fee-approval`;
        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    this.setState(
                        {
                            isLoading: false,
                            isRejected: false,
                            isApproved: false,
                            selectedFeeType: {},
                            remarks: '',
                            approverRemarks: ''
                        },
                        () => this.getStudentsInfo()
                    );
                    this.toast.show({ severity: 'success', summary: 'Success', detail: res?.res?.message, life: 3000 });
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name / Id" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };

    // Unassign dialog methods
    onHandleUnassign = (rowdata) => {
        // If amountPaid is 0, default to 'noAdjustments' option and disable it
        const defaultOption = rowdata.amountPaid === 0 ? 'noAdjustments' : (rowdata.unassignOption || '');
        
        this.setState({
            openUnAssignDialog: true,
            unAssignInfo: rowdata,
            // Pre-populate with existing data from the request
            unassignOption: defaultOption,
            unassignAmount: rowdata.unassignAmount || '',
            remarks: rowdata.remarks || '', // This will be the requested remarks (disabled)
            approverRemarks: '' // Reset approver remarks
        }, () => {
            // If adjust option was previously selected and we have installment amounts, 
            // we should fetch installments and populate them
            if (rowdata.unassignOption === 'adjust' && rowdata.installmentAmounts) {
                console.log('Opening dialog with adjust option and installmentAmounts:', rowdata.installmentAmounts);
                this.getFeeInstallments();
                // Set installment amounts after a short delay to ensure state is updated
                setTimeout(() => {
                    console.log('Setting installmentAmounts in state:', rowdata.installmentAmounts);
                    this.setState({
                        installmentAmounts: rowdata.installmentAmounts || []
                    });
                }, 100);
            }
        });
    }

    onHandleCancelUnAssign = () => {
        this.setState({
            openUnAssignDialog: false,
            unAssignInfo: {},
            unassignOption: '',
            unassignAmount: '',
            feeInstallments: [],
            installmentAmounts: [],
            remarks: '',
            approverRemarks: '',
            // Reset payment details dialog states
            showPaymentDetailsDialog: false,
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            accountNo: '',
            accountHolderName: '',
            ifscCode: '',
            rrNumber: '',
            upiId: ''
        })
    }

    // Method to fetch fee installments for adjustment option
    getFeeInstallments = () => {
        const studentId = this.state.unAssignInfo?.studentId || this.state.unAssignInfo?.user_id;
        if (!studentId) {
            console.log('No student ID found in unAssignInfo:', this.state.unAssignInfo);
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Student ID not found',
                life: 3000
            });
            return;
        }

        this.setState({ isLoadingInstallments: true });
        let academicYear = localStorage.getItem('userAcademicYear');

        let url = `${baseUrlAdmin}/concession/get-feetype-terms/${studentId}?academicYear=${academicYear}`;
        console.log('Fetching installments for student:', studentId, 'URL:', url);
        
        this.service.get(url, true).then(data => {
            console.log('Installments API response:', data);
            if (data?.status && data?.res?.data?.agg?.length) {
                // Filter out installments that have zero due amount
                const availableInstallments = data.res.data?.agg.filter(installment =>
                    installment?.feeTypeId !== this.state.unAssignInfo.feeTypeId
                );

                console.log('Available installments after filtering:', availableInstallments);
                this.setState({
                    feeInstallments: availableInstallments,
                    isLoadingInstallments: false,
                    installmentAmounts: [] // Reset installment amounts
                });
            } else {
                console.log('No installments found or API failed. Data:', data);
                this.setState({
                    feeInstallments: [],
                    isLoadingInstallments: false
                });
                if (!data?.status) {
                    this.toast.show({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Failed to fetch fee installments: ${data?.errMessage || 'Unknown error'}`,
                        life: 3000
                    });
                } else {
                    this.toast.show({
                        severity: 'info',
                        summary: 'Information',
                        detail: 'No fee installments available for adjustment',
                        life: 3000
                    });
                }
            }
        }).catch(error => {
            console.error('Error fetching installments:', error);
            this.setState({
                feeInstallments: [],
                isLoadingInstallments: false
            });
            this.toast.show({
                severity: 'error',
                summary: 'Error',
                detail: 'Error fetching fee installments',
                life: 3000
            });
        });
    }

    handleUnassignOptionChange = (option) => {
        console.log('Option changed to:', option, 'unAssignInfo:', this.state.unAssignInfo);
        this.setState({
            unassignOption: option,
            unassignAmount: '',
            installmentAmounts: []
        }, () => {
            // If adjust option is selected, fetch fee installments
            if (option === 'adjust') {
                console.log('Adjust option selected, calling getFeeInstallments');
                this.getFeeInstallments();
                // Also restore the original installment amounts if they exist
                if (this.state.unAssignInfo?.installmentAmounts) {
                    console.log('Restoring original installmentAmounts:', this.state.unAssignInfo.installmentAmounts);
                    setTimeout(() => {
                        this.setState({
                            installmentAmounts: this.state.unAssignInfo.installmentAmounts
                        });
                    }, 200);
                }
            }
        });
    }

    handleUnassignAmountChange = (value) => {
        const maxAmount = this.state.unAssignInfo?.amountPaid || 0;
        if (value <= maxAmount) {
            this.setState({ unassignAmount: value });
        } else {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Amount cannot exceed ₹${maxAmount}`,
                life: 3000
            });
        }
    }

    handleInstallmentAmountChange = (installment, value, individualDueAmount) => {
        const { installmentAmounts, unAssignInfo } = this.state;
        const maxAmount = unAssignInfo?.amountPaid || 0;

        // First check if the value exceeds the individual installment's due amount
        if (value > individualDueAmount) {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Amount cannot exceed installment due amount of ₹${individualDueAmount.toFixed(2)}`,
                life: 3000
            });
            return;
        }

        // Calculate current total of all installment amounts
        const otherAmounts = installmentAmounts
            .filter(item => item._id !== installment._id)
            .reduce((sum, item) => sum + (item.requestedAmount || 0), 0);

        const newTotal = otherAmounts + (value || 0);

        if (newTotal <= maxAmount) {
            // Update installmentAmounts array
            const updatedAmounts = installmentAmounts.filter(item => item._id !== installment._id);
            
            // Add new entry if value is greater than 0
            if (value > 0) {
                updatedAmounts.push({
                    ...installment,
                    requestedAmount: value,
                });
            }

            // Update unAssignInfo.installmentAmounts array separately, preserving existing entries
            const existingUnAssignInstallments = unAssignInfo?.installmentAmounts || [];
            const updatedUnAssignInstallments = existingUnAssignInstallments.filter(item => item._id !== installment._id);
            
            // Add new entry if value is greater than 0
            if (value > 0) {
                updatedUnAssignInstallments.push({
                    _id: installment._id,
                    feeTypeId: installment.feeTypeId,
                    requestedAmount: value
                });
            }

            // Update unAssignInfo with the updated installmentAmounts
            const updatedUnAssignInfo = {
                ...unAssignInfo,
                installmentAmounts: updatedUnAssignInstallments
            };

            this.setState({
                installmentAmounts: updatedAmounts,
                unAssignInfo: updatedUnAssignInfo
            });
        } else {
            this.toast.show({
                severity: 'warn',
                summary: 'Invalid Amount',
                detail: `Total amount cannot exceed ₹${maxAmount}`,
                life: 3000
            });
        }
    }

    // Validation methods
    validateAmounts = () => {
        const { unassignOption, unassignAmount, installmentAmounts, unAssignInfo, approverRemarks } = this.state;
        const maxAmount = unAssignInfo?.amountPaid || 0;

        // Check if action is selected (only required when amountPaid > 0)
        if (unAssignInfo?.amountPaid > 0 && !unassignOption) {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Please select at least one action',
                life: 3000
            });
            return false;
        }

        // Check if approver remarks are mandatory
        if (!approverRemarks || approverRemarks.trim() === '') {
            this.toast.show({
                severity: 'error',
                summary: 'Validation Error',
                detail: 'Approver remarks are mandatory',
                life: 3000
            });
            return false;
        }

        if (unassignOption === 'refund' || unassignOption === 'advance') {
            if (!unassignAmount || unassignAmount <= 0) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please enter a valid amount',
                    life: 3000
                });
                return false;
            }
            if (unassignAmount > maxAmount) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: `Amount cannot exceed ₹${maxAmount}`,
                    life: 3000
                });
                return false;
            }
        }

        if (unassignOption === 'adjust') {
            // Check both current installment amounts and original ones from unAssignInfo
            const currentInstallmentAmount = installmentAmounts
                .reduce((sum, item) => sum + (item.requestedAmount || 0), 0);
            
            const originalInstallmentAmount = unAssignInfo?.installmentAmounts
                ?.reduce((sum, item) => sum + (item.requestedAmount || 0), 0) || 0;
            
            // Use whichever has amounts - current changes or original amounts
            const totalInstallmentAmount = currentInstallmentAmount > 0 ? currentInstallmentAmount : originalInstallmentAmount;

            if (totalInstallmentAmount <= 0) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: 'Please enter amounts for at least one installment',
                    life: 3000
                });
                return false;
            }

            if (totalInstallmentAmount > maxAmount) {
                this.toast.show({
                    severity: 'error',
                    summary: 'Validation Error',
                    detail: `Total amount cannot exceed ₹${maxAmount}`,
                    life: 3000
                });
                return false;
            }
        }

        return true;
    }

    handleUnassignWithApproval = () => {
        // Always validate (for all cases)
        if (!this.validateAmounts()) {
            return;
        }

        let academicYear = localStorage.getItem('userAcademicYear')
        let payload = {
            ...this.state.unAssignInfo,
            user_id: this.state.unAssignInfo?.user_id,
            academicYear: academicYear,
            remarks: this.state.remarks, // Original requested remarks
            approverRemarks: this.state.approverRemarks, // New approver remarks
            isAssigned: true, // Directly approve the unassign
            handledBy: this.state.unAssignInfo?.handledBy || [],
            levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == this.state.unAssignInfo?.branchId)
        }

        // Add new fields based on amountPaid and unassign option
        if (this.state.unAssignInfo.amountPaid > 0) {
            payload.unassignOption = this.state.unassignOption;

            if (this.state.unassignOption === 'refund') {
                payload.unassignAmount = this.state.unassignAmount;
                // Add parent bank information for refund option
                if (this.state.unAssignInfo.parentBankInfo) {
                    payload.parentBankInfo = this.state.unAssignInfo.parentBankInfo;
                }
            } else if (this.state.unassignOption === 'advance') {
                payload.unassignAmount = this.state.unassignAmount;
            } else if (this.state.unassignOption === 'adjust') {
                // Use current installmentAmounts if modified, otherwise use original ones
                const currentHasAmounts = this.state.installmentAmounts.length > 0;
                const finalInstallmentAmounts = currentHasAmounts
                    ? this.state.installmentAmounts
                    : this.state.unAssignInfo?.installmentAmounts || [];

                payload.installmentAmounts = finalInstallmentAmounts;
            }
        }

        this.setState({ isLoading: true })
        let url = `${baseUrlAdmin}/unassign-approval/unassign-fee-approval`
        this.service.post(url, payload, true).then((data) => {
            if (data.status) {
                this.setState({
                    isLoading: false,
                    openUnAssignDialog: false,
                    remarks: '',
                    approverRemarks: '',
                    unassignOption: '',
                    unassignAmount: '',
                    installmentAmounts: [],
                    unAssignInfo: {}
                }, () => this.getStudentsInfo())
                this.toast?.show({ severity: 'success', summary: 'Success', detail: data.errMessage, life: 3000 });

            }
            else {
                this.setState({ isLoading: false })
                this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
            }

        }).catch(error => {
            this.setState({ isLoading: false })
            this.toast.show({ severity: 'error', summary: 'Some error occured', detail: 'Error Occured', life: 3000 });

        })
    }

    // Payment Details Dialog Methods
    onShowPaymentDetails = () => {
        // Pre-populate payment details from the original request if available
        const parentBankInfo = this.state.unAssignInfo?.parentBankInfo || {};
        this.setState({
            showPaymentDetailsDialog: true,
            openUnAssignDialog: false,
            // Pre-populate with existing data
            paymentType: parentBankInfo.paymentType || '',
            chequeIssuedTo: parentBankInfo.chequeIssuedTo || '',
            chequeNo: parentBankInfo.chequeNo || '',
            chequeDate: parentBankInfo.chequeDate || null,
            bankName: parentBankInfo.bankName || '',
            bankBranchName: parentBankInfo.bankBranchName || '',
            accountNo: parentBankInfo.accountNo || '',
            accountHolderName: parentBankInfo.accountHolderName || '',
            ifscCode: parentBankInfo.ifscCode || '',
            rrNumber: parentBankInfo.rrNumber || '',
            upiId: parentBankInfo.upiId || ''
        });
    }

    onClosePaymentDetails = () => {
        this.setState({
            showPaymentDetailsDialog: false,
            openUnAssignDialog: true,
            // Reset payment details
            paymentType: '',
            chequeIssuedTo: '',
            chequeNo: '',
            chequeDate: null,
            bankName: '',
            bankBranchName: '',
            accountNo: '',
            accountHolderName: '',
            ifscCode: '',
            rrNumber: '',
            upiId: ''
        });
    }

    onApproveWithPaymentDetails = () => {
        // Add payment details to unAssignInfo and then approve
        const updatedUnAssignInfo = {
            ...this.state.unAssignInfo,
            parentBankInfo: {
                paymentType: this.state.paymentType,
                chequeIssuedTo: this.state.chequeIssuedTo,
                chequeNo: this.state.chequeNo,
                chequeDate: this.state.chequeDate,
                bankName: this.state.bankName,
                bankBranchName: this.state.bankBranchName,
                accountNo: this.state.accountNo,
                accountHolderName: this.state.accountHolderName,
                ifscCode: this.state.ifscCode,
                rrNumber: this.state.rrNumber,
                upiId: this.state.upiId
            }
        };

        this.setState({
            unAssignInfo: updatedUnAssignInfo,
            showPaymentDetailsDialog: false
        }, () => {
            // Now proceed with the approval
            this.handleUnassignWithApproval();
        });
    }

    render() {

        const header = this.renderHeader();
        return (
            <div className="ma-main">
                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">
                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton inputId="ingredient1" onChange={(e) => this.handleSearchLevel(1)} checked={this.state.searchLevel === 1} />
                        </div>

                        <div>
                            <BranchToSectionApprovalHierarchy selectedValue={this.state.searchLevel} setValues={this.setDropdownValues} approvalType={'feeUnassign'} />
                        </div>
                    </div>
                    {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div> */}
                    {/* <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center -mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">
                            <ClassetStudentSearchFilter
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                            />
                        </div>
                    </div> */}
                    {/* <div style={{ marginLeft: '100px' }} className="flex justify-content-start align-items-center">
                        <span className="">OR</span>
                    </div>
                    <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center -mt-3">
                            <RadioButton inputId="ingredient2" onChange={(e) => this.handleSearchLevel(2)} checked={this.state.searchLevel === 2} />
                        </div>

                        <div className="field ml-4">
                            <ClassetStudentSearch selectedValue={this.state.searchLevel} handleTypeValue={this.handleSetSearchTypeValue} handleSearchValue={this.handleSetSearchValue} />
                        </div>
                    </div> */}

                    {/* <div className="col-12 ml-5">
                        <label className="label">
                            Student<span className="ma-required">*</span>
                        </label>
                        <div className="mt-2">
                            <ClassetDropdown
                                icon={<MailIcon />}
                                id="student"
                                className=""
                                height="48px"
                                width="327px"
                                options={this.state?.students}
                                value={this.state.studentId}
                                disabled={this.state?.searchLevel === 2}
                                //     onChange={(e) => {this.setState({studentId:e.value})
                                //     this.getTermBasedData()

                                // }}
                                onChange={this.onStudentChange}
                                placeholder={
                                    <div>
                                        <span className="">Select Student</span>
                                    </div>
                                }
                            />
                        </div>
                    </div> */}
                </div>

                <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.studentInfo}
                    dataKey="id"
                    paginator
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    // selection={this.state.selectedProducts}
                    // onSelectionChange={(e) => this.setState((prevState)=>({selectedProducts:[...prevState.selectedProducts,e.value]}))}
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.totalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.totalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                    // paginator
                    // //filter 
                    selection={this.state.selectedRows}
                    onSelectionChange={this.onSelectionChange}
                    lazy={false} // Changed to false for front-end pagination
                    header={header}
                    rowHover
                    filters={this.state.filters} filterDisplay="menu" loading={this.state.loading}
                    globalFilterFields={[
                        'firstName',
                        'lastName',
                        'username',
                        'parentContactNo',
                        // 'enrollmentId',
                        // 'boardName',
                        // 'gradeName',
                        // 'sectionName',
                        // 'totalFee',
                        // 'concessionRaisedAmt'
                    ]}
                >
                    <Column
                        alignHeader={'center'}
                        sortable
                        bodyClassName="text-center"
                        header="Student Name"
                        body={(rowData, { rowIndex }) => {
                            return (
                                <div className="flex justify-content-center">
                                    {rowData?.firstName} {rowData?.lastName}
                                </div>
                            );
                        }}
                    ></Column>
                    <Column filterField="" field="username" sortable bodyClassName="text-center" header="Enrollment No" alignHeader={'center'} body={(rowData) => rowData.username ? rowData.username.slice(3) : ''} />
                    <Column sortable bodyClassName="text-center" header="Board" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.boardName}
                            </div>
                        )
                    }} />
                    <Column sortable bodyClassName="text-center" header="Grade-Section" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.className} - {rowData?.sectionName}
                            </div>
                        )
                    }} />
                    <Column filterField="" field="feeType" sortable bodyClassName="text-center" header="Fee Type" alignHeader={'center'} />
                    <Column filterField="" field="totalAmount" sortable bodyClassName="text-center" header="Total Fee" alignHeader={'center'} />
                    <Column filterField="" field="concession" sortable bodyClassName="text-center" header="Concession" alignHeader={'center'} />
                    <Column filterField="" field="fineAmt" sortable bodyClassName="text-center" header="Fine Amount" alignHeader={'center'} />
                    <Column filterField="" field="dueAmount" sortable bodyClassName="text-center" header="Total Due" alignHeader={'center'} />
                    <Column
                        style={{ width: '15rem', height: '6rem' }}
                        alignHeader={'center'}
                        sortable
                        headerClassName="text-color-secondary"
                        bodyClassName="text-center"
                        className=" "
                        header="Approve / Reject"
                        body={(rowData, { rowIndex }) => {
                            return (
                                <>
                                    {rowData?.isRefundApproved == undefined && (
                                        <div className="flex justify-content-evenly">
                                            <div className="cursor-pointer" onClick={() => this.onHandleUnassign(rowData)}>
                                                <GreenCheck />
                                            </div>

                                            <div className="cursor-pointer" onClick={() => this.onHandleFeUnassignApprove(rowData, false)}>
                                                <CancelRed />
                                            </div>
                                        </div>
                                    )}
                                </>
                            );
                        }}
                    ></Column>
                </DataTable>

                {/* Unassign Dialog */}
                <Dialog
                    blockScroll={false}
                    visible={this.state.openUnAssignDialog}
                    draggable={false}
                    resizable={false}
                    style={{
                        borderRadius: '16px',
                        width: this.state.unassignOption === 'adjust' ? "80vw" : "500px",
                        minHeight: "400px"
                    }}
                    closable={true}
                    onHide={this.onHandleCancelUnAssign}
                    footer={() => {
                        const buttonLabel = this.state.unassignOption === 'refund'
                            ? "Next"
                            : "Approve & Unassign";
                        const buttonHandler = this.state.unassignOption === 'refund'
                            ? this.onShowPaymentDetails
                            : this.handleUnassignWithApproval;
                        return (
                            <div className='flex justify-content-center'>
                                <Button label={buttonLabel} className='confirmDialogAcceptBtn mr-4  px-6' onClick={buttonHandler} />
                                <Button style={{ color: "black" }} label="Cancel" className='confirmDialogCancelBtn px-6' onClick={this.onHandleCancelUnAssign} />
                            </div>
                        );
                    }}
                >
                    <div className='text-center mb-4'>
                        <TickBgIcon width={32} height={32} color="#268900" />
                        <h4 className="confirmDialogHeader" style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '20px', lineHeight: '24px', letterSpacing: '0.15px' }}>Review Unassign Fee Request</h4>
                        <div className="mt-3">
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Student: {this.state.unAssignInfo?.firstName} {this.state.unAssignInfo?.lastName}
                            </p>
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Fee Type: {this.state.unAssignInfo?.feeType}
                            </p>
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Total Fee: ₹{this.state.unAssignInfo?.totalAmount}
                            </p>
                            <p className="text-lg font-semibold" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                Paid Amount: ₹{this.state.unAssignInfo?.amountPaid || 0}
                            </p>
                            {this.state.unAssignInfo?.requestedBy && (
                                <p className="text-sm" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>
                                    Requested by: {this.state.unAssignInfo?.adminUserName}
                                </p>
                            )}
                        </div>
                    </div>

                    {/* Show radio button options - Only show selected option */}
                    <div className="mb-4">
                        <label className='label mb-3' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                            Select Action{this.state.unAssignInfo?.amountPaid > 0 ? <span className='ma-required'>*</span> : ''}
                        </label>
                        <div className="flex flex-column gap-3">
                            {/* Show only the selected option */}
                            {this.state.unassignOption === 'refund' && (
                                <div className="p-3 border-round" style={{ backgroundColor: '#D1E4FF', border: '2px solid #076EFF', cursor: 'pointer' }}>
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="refund"
                                            name="unassignOption"
                                            value="refund"
                                            onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                            checked={true}
                                            disabled={false}
                                        />
                                        <label htmlFor="refund" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                            Raise Refund
                                        </label>
                                    </div>
                                    <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Process refund for the paid amount</p>
                                </div>
                            )}

                            {this.state.unassignOption === 'advance' && (
                                <div className="p-3 border-round" style={{ backgroundColor: '#D1E4FF', border: '2px solid #076EFF', cursor: 'pointer' }}>
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="advance"
                                            name="unassignOption"
                                            value="advance"
                                            onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                            checked={true}
                                            disabled={false}
                                        />
                                        <label htmlFor="advance" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                            Move to Advance
                                        </label>
                                    </div>
                                    <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Transfer amount to student's advance balance</p>
                                </div>
                            )}

                            {this.state.unassignOption === 'adjust' && (
                                <div className="p-3 border-round" style={{ backgroundColor: '#D1E4FF', border: '2px solid #076EFF', cursor: 'pointer' }}>
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="adjust"
                                            name="unassignOption"
                                            value="adjust"
                                            onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                            checked={true}
                                            disabled={false}
                                        />
                                        <label htmlFor="adjust" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                            Adjust for Remaining Fee Installments
                                        </label>
                                    </div>
                                    <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Distribute amount to other pending fee installments</p>
                                </div>
                            )}

                            {this.state.unassignOption === 'noAdjustments' && (
                                <div className="p-3 border-round" style={{ backgroundColor: '#D1E4FF', border: '2px solid #076EFF', cursor: 'pointer' }}>
                                    <div className="flex align-items-center">
                                        <RadioButton
                                            inputId="noAdjustments"
                                            name="unassignOption"
                                            value="noAdjustments"
                                            onChange={(e) => this.handleUnassignOptionChange(e.value)}
                                            checked={true}
                                            disabled={false}
                                        />
                                        <label htmlFor="noAdjustments" className="ml-2 font-semibold cursor-pointer" style={{ fontFamily: 'InterRegular', fontWeight: 500, fontSize: '16px', lineHeight: '24px', letterSpacing: '0.5px' }}>
                                            No Adjustments
                                        </label>
                                    </div>
                                    <p className="text-sm text-600 mt-2 ml-4" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#4E616B' }}>Keep the amount as closing fee type amount</p>
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Amount input for Refund and Advance options */}
                    {(this.state.unassignOption === 'refund' || this.state.unassignOption === 'advance') && (
                        <div className="mb-4">
                            <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                Amount<span className='ma-required'>*</span>
                                <span className="text-sm text-500 ml-2" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '12px', lineHeight: '18px', letterSpacing: '0.4px', color: '#667A85' }}>
                                    (Max: ₹{this.state.unAssignInfo?.amountPaid})
                                </span>
                            </label>
                            <div className="mt-2">
                                <ClassetInputText
                                    value={this.state.unassignAmount}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        // Only allow numbers and decimal point
                                        if (/^\d*\.?\d*$/.test(value)) {
                                            this.handleUnassignAmountChange(parseFloat(value) || 0);
                                        }
                                    }}
                                    disabled={true}
                                    placeholder="Enter amount"
                                    className="w-full"
                                    height="48px"
                                    width="100%"
                                />
                            </div>

                            {/* Show note when amount is less than paid amount */}
                            {this.state.unassignAmount > 0 && this.state.unassignAmount < this.state.unAssignInfo?.amountPaid && (
                                <div className="mt-2 p-2 bg-yellow-50 border-1 border-yellow-200 border-round">
                                    <p className="text-sm text-yellow-800 mb-1" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                        <i className="pi pi-info-circle mr-2"></i>
                                        <strong>Note:</strong> Remaining ₹{(this.state.unAssignInfo?.amountPaid - this.state.unassignAmount).toFixed(2)} amount will be considered as closing Fee Type amount.
                                    </p>
                                    <p className="text-sm text-yellow-700" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                        ₹{this.state.unassignAmount} amount will be {this.state.unassignOption === 'refund' ? 'refunded' : 'moved to advance'}.
                                    </p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Installment list for Adjust option */}
                    {this.state.unassignOption === 'adjust' && (
                        <div className="mb-4">
                            <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                Distribute Amount to Fee Installments<span className='ma-required'>*</span>
                                <span className="text-sm text-500 ml-2" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '12px', lineHeight: '18px', letterSpacing: '0.4px', color: '#667A85' }}>
                                    (Total Max: ₹{this.state.unAssignInfo?.amountPaid})
                                </span>
                            </label>

                            {(() => {
                                console.log('Render conditions - isLoadingInstallments:', this.state.isLoadingInstallments, 'feeInstallments:', this.state.feeInstallments);
                                return null;
                            })()}

                            {this.state.isLoadingInstallments ? (
                                <div className="text-center py-4">
                                    <LoadingComponent />
                                    <p style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Loading fee installments...</p>
                                </div>
                            ) : this.state.feeInstallments.length > 0 ? (
                                <div className="mt-2">
                                    <DataTable
                                        value={this.state.feeInstallments}
                                        responsiveLayout="scroll"
                                        className="dataTableValuesText"
                                        showGridlines
                                        size="small"
                                    >
                                        <Column
                                            header='Sl.No'
                                            alignHeader={'center'}
                                            bodyClassName='text-center'
                                            style={{ width: '8%' }}
                                            body={(rowData, { rowIndex }) => {
                                                return (<span>{rowIndex + 1}</span>)
                                            }}
                                        />

                                        <Column filterField="feeType" field="feeType" sortable bodyClassName='text-center' header="Fee Type" alignHeader={"center"} />
                                        <Column filterField="feeTermName" sortable bodyClassName='text-center' header="Fee Term Name" alignHeader={"center"} body={(rowData, index) => {
                                            return (
                                                <p>{`Installment ${rowData?.term}`}</p>
                                            )
                                        }} />
                                        <Column filterField="termWiseActualValue" field="termWiseActualValue" sortable bodyClassName='text-center' header="Term wise Actual Fee" alignHeader={"center"}
                                            body={(rowData, { rowIndex }) => {
                                                return <div className="flex justify-content-center">{` ${Math.round((rowData?.termWiseActualValue) * 100) / 100}`}</div>;
                                            }} />
                                        <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName='text-center' header="Paid Fee" alignHeader={"center"} />
                                        <Column filterField="totalDue" field="" sortable bodyClassName='text-center' header="Total Due" alignHeader={"center"} body={(rowData, index) => {
                                            let dueAmount = (Number(rowData?.dueAmount || 0))
                                            let conAmt = Number(rowData?.currentConAmt) || 0
                                            let finalDue = Number(dueAmount - conAmt).toFixed(2)
                                            return (
                                                <p>{finalDue}</p>
                                            )
                                        }} />
                                        <Column bodyClassName='text-center' header="Amount Paying" body={(rowData, index) => {
                                            let dueAmount = (Number(rowData?.dueAmount || 0))
                                            let conAmt = Number(rowData?.currentConAmt) || 0
                                            let finalDue = Number(dueAmount - conAmt)
                                            let isDisabled = finalDue <= 0

                                            return (
                                                <ClassetInputText
                                                    className="text-xl hide-number-spinners"
                                                    type="text"
                                                    height="48px"
                                                    width="216px"
                                                    placeholder={isDisabled ? 'No Due Amount' : 'Enter Value'}
                                                    value={(() => {
                                                        const matchedItem = this.state.unAssignInfo?.installmentAmounts?.find(item => item._id === rowData?._id);
                                                        console.log('Finding value for rowData._id:', rowData?._id, 'installmentAmounts:', this.state.installmentAmounts, 'matchedItem:', matchedItem);
                                                        return matchedItem?.requestedAmount || '';
                                                    })()}
                                                    onChange={(e) => {
                                                        const value = e.target.value;
                                                        if (value === '' || value.match(/^\d*\.?\d{0,2}$/)) {
                                                            this.handleInstallmentAmountChange(rowData, parseFloat(value) || 0, finalDue);
                                                        }
                                                    }}
                                                    onWheel={(e) => e.target.blur()}
                                                    disabled={true}
                                                    style={isDisabled ? { backgroundColor: '#f5f5f5', color: '#999' } : {}}
                                                />
                                            )
                                        }} />
                                    </DataTable>

                                    {/*      <div className="mt-3 p-3 bg-blue-50 border-round">
                                        <div className="grid">
                                            <div className="col-6">
                                                <p className="text-sm font-semibold text-blue-900 mb-1" style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    Total Allocated: ₹{this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0)}
                                                </p>
                                            </div>
                                            <div className="col-6">
                                                <p className="text-sm font-semibold text-blue-700 mb-1" style={{ fontFamily: 'InterSemiBold', fontWeight: 600, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    Remaining: ₹{this.state.unAssignInfo?.amountPaid - this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0)}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
 */}
                                    {/* Show note when some amount is allocated but not all */}
                                    {this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0) > 0 &&
                                        this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0) < this.state.unAssignInfo?.amountPaid && (
                                            <div className="mt-2 p-2 bg-yellow-50 border-1 border-yellow-200 border-round">
                                                <p className="text-sm text-yellow-800 mb-1" style={{ fontFamily: 'InterMedium', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    <i className="pi pi-info-circle mr-2"></i>
                                                    <strong>Note:</strong> Remaining ₹{(this.state.unAssignInfo?.amountPaid - this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0)).toFixed(2)} amount will be considered as closing Fee Type amount.
                                                </p>
                                                <p className="text-sm text-yellow-700" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>
                                                    ₹{this.state.installmentAmounts.reduce((sum, item) => sum + (item.requestedAmount || 0), 0)} amount will be distributed to the selected installments.
                                                </p>
                                            </div>
                                        )}
                                </div>
                            ) : (
                                <div className="text-center py-4 text-500">
                                    <p style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px', color: '#667A85' }}>No fee installments available for adjustment</p>
                                </div>
                            )}
                        </div>
                    )}

                    {/* Remarks section */}
                    <div className="mb-2">
                        {/* Requested Remarks - Display as text */}
                        {this.state.remarks && (
                            <div className="mb-3">
                                <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Requested Remarks:</label>
                                <div className="mt-2 p-3 border-round" style={{ backgroundColor: '#f8f9fa', border: '1px solid #e9ecef', minHeight: '48px', fontFamily: 'InterRegular', fontSize: '14px', lineHeight: '21px', color: '#495057' }}>
                                    {this.state.remarks}
                                </div>
                            </div>
                        )}



                        {/* Approver Remarks - Editable */}
                        <div>
                            <label className='label mb-2' style={{ fontFamily: 'InterSemiBold', fontWeight: 500, fontSize: '14px', lineHeight: '21px', letterSpacing: '0.25px' }}>Approver Remarks<span className='ma-required'>*</span></label>
                            <div className="mt-2">
                                <ClassetTextArea
                                    className=""
                                    height="48px"
                                    width="100%"
                                    placeholder="Enter your remarks as approver"
                                    value={this.state.approverRemarks}
                                    onChange={(e) => this.setState({ approverRemarks: e.target.value })}
                                />
                            </div>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.isRejected}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <CrossInBox bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Reject Unassign Fee</p>
                                <p style={{ fontWeight: 'semiRegular', fontSize: 14 }}>Fee Type : {this.state.selectedFeeType?.feeType}</p>
                                <p style={{ fontWeight: 'semiRegular', fontSize: 14 }}>Total Amount : {this.state.selectedFeeType?.totalAmount}</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#BF0031', border: 'none' }}
                                onClick={() => {
                                    this.onUnassignFeeConfirm(false);
                                }}
                            >
                                <p className="formSubmitButtonText">Reject</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isRejected: false, selectedFeeType: {}, approverRemarks: '' })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isRejected: false, selectedFeeType: {}, approverRemarks: '' })}
                >
                    <div className=" m-3 pt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <div className="">
                            <ClassetTextArea width={'100%'} style={{ height: '119px' }} label={'Approver Remarks:'} placeholder="Enter your remarks" value={this.state.approverRemarks} onChange={(e) => this.setState({ approverRemarks: e.target.value })} />
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    visible={this.state.isApproved}
                    draggable={false}
                    closeOnEscape={false}
                    style={{ width: 400 }}
                    dismissableMask={false}
                    closable={false}
                    header={() => {
                        return (
                            <div className="mt-2 formHeadingInter">
                                <div className="mb-3">
                                    <RightMarkInCircle bgcolor={'#BF0031'} color={'white'} />
                                </div>
                                <p style={{ fontWeight: 'bold', fontSize: 20 }}>Confirm Unassign Fee </p>
                                <p style={{ fontWeight: 'semiRegular', fontSize: 14 }}>Fee Type : {this.state.selectedFeeType?.feeType}</p>
                                <p style={{ fontWeight: 'semiRegular', fontSize: 14 }}>Total Amount : {this.state.selectedFeeType?.totalAmount}</p>
                            </div>
                        );
                    }}
                    footer={() => (
                        <div className="flex justify-content-center mb-4">
                            <Button
                                className="formSubmitButton px-4"
                                style={{ borderRadius: '10px', backgroundColor: '#7CDD56', border: 'none' }}
                                onClick={() => {
                                    this.onUnassignFeeConfirm(true);
                                }}
                            >
                                <p className="formSubmitButtonText">Approve</p>
                            </Button>
                            <Button className="formCancelButton px-4" style={{ backgroundColor: '#F4F5F6', border: 0 }} onClick={() => this.setState({ isApproved: false, selectedFeeType: {}, approverRemarks: '' })}>
                                <p className="formCancelButtonText">Cancel</p>
                            </Button>
                        </div>
                    )}
                    onHide={() => this.setState({ isApproved: false, selectedFeeType: {}, approverRemarks: '' })}
                >
                    <div className=" m-3 pt-3" style={{ alignItems: 'center', justifyContent: 'center' }}>
                        <div className="">
                            <ClassetTextArea width={'100%'} style={{ height: '119px' }} label={'Approver Remarks:'} placeholder="Enter your remarks" value={this.state.approverRemarks} onChange={(e) => this.setState({ approverRemarks: e.target.value })} />
                        </div>
                    </div>
                </Dialog>

                {/* Payment Details Dialog for Refund Approval */}
                <Dialog
                    visible={this.state.showPaymentDetailsDialog}
                    style={{ width: "400px", height: '80vh', minHeight: '600px' }}
                    draggable={false}
                    onHide={this.onClosePaymentDetails}
                    closable={false}
                    header={() => {
                        return (
                            <div className='mt-2 mb-4'>
                                <h3 className="formhead text-center">Payment Details</h3>
                                <p className="text-center text-sm" style={{ fontFamily: 'InterRegular', fontWeight: 400, fontSize: '14px', color: '#666' }}>
                                    Review and confirm parent payment details for refund
                                </p>
                            </div>
                        )
                    }}
                >
                    <div style={{ height: 'calc(100% - 0px)', display: 'flex', flexDirection: 'column', position: 'relative' }}>
                        <div className="flex flex-column align-items-center flex-1" style={{ overflowY: 'auto', paddingBottom: '20px' }}>
                            <div className="w-full flex justify-content-center mt-3">
                                <div style={{ width: '300px' }}>
                                    <label className="label mb-2">
                                        Payment Mode<span className="ma-required">*</span>
                                    </label>
                                    <div className="mt-2">
                                        <ClassetDropdown
                                            id="paymentType"
                                            className=""
                                            height="48px"
                                            width="100%"
                                            options={paymentModes?.filter(el =>
                                                el.label !== "Adjustment" &&
                                                el.label !== "Credit Card" &&
                                                el.label !== "Debit Card"
                                            )}
                                            value={this.state.paymentType}
                                            onChange={() => { }}
                                            placeholder={
                                                <div>
                                                    <span className="">Select Payment Mode</span>
                                                </div>
                                            }
                                            disabled={true}
                                            style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* Online fields */}
                            {this.state.paymentType === '1b1a76b4-c538-4968-a20b-0e5a3b4a1c54' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Account Holder Name<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="accountHolderName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Account Holder Name"
                                                    value={this.state.accountHolderName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Account Number<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="accountNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Account Number"
                                                    value={this.state.accountNo}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                IFSC Code<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="ifscCode"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter IFSC Code"
                                                    value={this.state.ifscCode}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name & Branch<span className="ma-required">*</span>
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name & Branch"
                                                    value={this.state.bankName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* QR Code fields */}
                            {this.state.paymentType === '32b180cf-7727-46ef-b2a8-e7b1b19fd489' && (
                                <div className="w-full flex justify-content-center mt-3">
                                    <div style={{ width: '300px' }}>
                                        <label className="label mb-2">
                                            UPI ID<span className="ma-required">*</span>
                                        </label>
                                        <div className="mt-2">
                                            <ClassetInputText
                                                id="upiId"
                                                height="48px"
                                                width="100%"
                                                placeholder="Enter UPI ID"
                                                value={this.state.upiId}
                                                onChange={() => { }}
                                                disabled={true}
                                                style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Cheque fields */}
                            {this.state.paymentType === '1c98862e-46dc-4454-a120-7d15e2e56e2f' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeNo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Cheque Number"
                                                    value={this.state.chequeNo}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Cheque Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select Cheque Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* DD fields */}
                            {this.state.paymentType === '9d08ebab-2d3e-4a30-8460-4e4092fe30a1' && (
                                <>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Issued To
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="chequeIssuedTo"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Issued To"
                                                    value={this.state.chequeIssuedTo}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Number
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="rrNumber"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter DD Number"
                                                    value={this.state.rrNumber}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                DD Date
                                            </label>
                                            <div className="mt-2">
                                                <ClassetCalendar
                                                    className=""
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Select DD Date"
                                                    calendarMode="single"
                                                    value={this.state.chequeDate}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Name"
                                                    value={this.state.bankName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-full flex justify-content-center mt-3">
                                        <div style={{ width: '300px' }}>
                                            <label className="label mb-2">
                                                Bank Branch Name
                                            </label>
                                            <div className="mt-2">
                                                <ClassetInputText
                                                    id="bankBranchName"
                                                    height="48px"
                                                    width="100%"
                                                    placeholder="Enter Bank Branch Name"
                                                    value={this.state.bankBranchName}
                                                    onChange={() => { }}
                                                    disabled={true}
                                                    style={{ backgroundColor: '#f5f5f5', color: '#999', cursor: 'not-allowed' }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}

                            {/* Add extra bottom space */}
                            <div style={{ height: '30px' }}></div>
                        </div>

                        {/* Fixed buttons at bottom */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            gap: '15px'
                        }}>
                            <Button
                                label='Approve & Unassign'
                                className='submitButtonn button text-lg'
                                style={{ width: "200px" }}
                                onClick={this.onApproveWithPaymentDetails}
                            />
                            <Button
                                style={{ width: "150px" }}
                                className='cancelButtonn'
                                onClick={this.onClosePaymentDetails}
                            >
                                <p className='cancelButtonnText'>Cancel</p>
                            </Button>
                        </div>
                    </div>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

export default withRouter(Authentication(FeeUnassignApproval));
